import React from "react";
import tw, { css } from "twin.macro";

import { BookMeeting } from "../../components/BookMeeting";
import { Container } from "../../components/Container";
import HowItWorksCards from "./how_it_works/HowItWorksCards";

const cards = css`
  ${tw`py-8 max-w-5xl mx-auto flex flex-wrap items-center`}
`;

const HowItWorksIndex: React.FC = ({ ...rest }) => {
  return (
    <Container {...rest}>
      <section css={cards}>
        <HowItWorksCards />
        <BookMeeting commentFirst={true} />
      </section>
    </Container>
  );
};

export default HowItWorksIndex;
